/** Согласие на обработку ПДн и cookie перед входом/регистрацией (client-only). */
export const PDN_COOKIE_CONSENT_STORAGE_KEY = "hubcrm.consent.pdn_cookies_v1";

export function hasPdnCookieConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(PDN_COOKIE_CONSENT_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setPdnCookieConsent(): void {
  try {
    window.localStorage.setItem(PDN_COOKIE_CONSENT_STORAGE_KEY, "1");
  } catch {
    // private mode / quota — без записи вход остаётся заблокированным на стороне UI
  }
}
